import { createFeature, createReducer, on } from '@ngrx/store';
import { DocusignActions } from '../../actions/docusign/docusign.actions';
import { UserActions } from '@store/actions/user/user.actions';
import { environment } from "@environments/environment";

export const docusignFeatureKey = 'docusign';

export interface State {
  userDocusignID: string,
  sendingEnvelope: boolean
}

export const initialState: State = {
  userDocusignID: "",
  sendingEnvelope: false
};

export const reducer = createReducer(
  initialState,

  on(DocusignActions.sendDocusignEnvelopeButtonPressed, (state, action) => ({
    ...state,
    sendingEnvelope: true
  })),
  on(DocusignActions.sendDocusignEnvelopeSuccess, (state, action) => ({
    ...state,
    sendingEnvelope: false
  })),
  on(DocusignActions.sendDocusignEnvelopeFailure, (state, action) => ({
    ...state,
    sendingEnvelope: false
  })),
);

export const docusignFeature = createFeature({
  name: docusignFeatureKey,
  reducer,
});

